<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader @click="collapsed = !collapsed">Customer Sales Last 30 Days
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize">
            <CIcon :name="`cil-chevron-${collapsed ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed" :duration="400">
        <CCardBody>
          <div style="width:100%;float:left;" v-if="data && !loading">
            <CRow>
              <CCol sm="4">
                <CCallout color="success">
                  <small class="text-muted">Total $ Sold</small><br>
                  <strong class="h4">${{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong>
                </CCallout>
              </CCol>
              <CCol sm="4">
                <CCallout color="danger">
                  <small class="text-muted">Total Units</small><br>
                  <strong class="h4">{{totalUnits.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong>
                </CCallout>
              </CCol>
              <CCol sm="4">
                <CCallout color="danger">
                  <small class="text-muted">Total Orders</small><br>
                  <strong class="h4">{{totalOrders.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong>
                </CCallout>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="4">
                <div style="width:100%;float:left;" v-if="data" v-for="(val, key) in data">
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <span class="title">{{key}}</span>
                      <span class="ml-auto font-weight-bold">
                        ${{val.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span class="text-muted small">({{parseFloat(configurePercent(val)).toFixed(2)}}%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="configurePercent(val)"
                        color="success"
                      />
                    </div>
                  </div>
                </div>
              </CCol>
              <CCol sm="4">
                <div style="width:100%;float:left;" v-if="data" v-for="(val, key) in data">
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <span class="title">{{key}}</span>
                      <span class="ml-auto font-weight-bold">
                        {{val.total_units.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span class="text-muted small">({{parseFloat(configurePercentUnits(val)).toFixed(2)}}%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="configurePercentUnits(val)"
                        color="danger"
                      />
                    </div>
                  </div>
                </div>
              </CCol>
              <CCol sm="4">
                <div style="width:100%;float:left;" v-if="data" v-for="(val, key) in data">
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <span class="title">{{key}}</span>
                      <span class="ml-auto font-weight-bold">
                        {{val.totalOrders.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span class="text-muted small">({{parseFloat(configurePercentOrders(val)).toFixed(2)}}%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="configurePercentOrders(val)"
                        color="danger"
                      />
                    </div>
                  </div>
                </div>
              </CCol>
            </CRow>
          </div>
          <small-loader v-else></small-loader>
            <!-- <div style="width:30%;float:left;height:75px;">
              <div style="width:100%;float:left;text-align:center;">
                <label style="width:100%;float:left;text-align:center;font-size:.7em;">{{key}}</label>
                <label style="width:100%;float:left;text-align:center;font-size:.7em;">{{val.label}}</label>
              </div>
            </div>
            <div style="width:70%;float:left;height:75px;">
              <label style="width:100%;float:left;text-align:center;">
                ${{val.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} ({{parseFloat(configurePercent(val)).toFixed(2)}}%)
              </label>
              <div style="width:100%;float:left;">
                <CProgress
                  class="progress-xs"
                  :value="configurePercent(val)"
                  color="info"
                />
              </div>
            </div> -->
          <!-- </div> -->
          <!-- <div style="width:100%;float:left;" v-if="data">
            <CChartBar
              :datasets="data"
              labels="customers"
            />
          </div> -->
          <small-loader v-else></small-loader>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>
<script>
var methods = {}
import { CChartBar } from '@coreui/vue-chartjs'

methods.getData = function () {
  this.loading = true
  const postData = {
    customer: this.customer_selected
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/reports/customers_30_days?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log('customersssss')
    console.log(response)
    var obj = {}
    this.total = 0
    this.totalOrders = 0
    var that = this
    response.data.forEach(function (val) {
      if (!obj[val.customer_number]) {
        obj[val.customer_number] = {
          label: val.customer_info.customer_name,
          total: 0,
          totalOrders: 0,
          total_units: 0
        }
      }
      obj[val.customer_number].total += parseFloat(val.price)
      obj[val.customer_number].totalOrders++
      // obj[val.customer_number].total_units
      val.order_items.forEach(function (v) {
        obj[val.customer_number].total_units += parseInt(v.units) || 0
        that.totalUnits += parseInt(v.units) || 0
      })
      that.total += parseFloat(val.price || 0)
      that.totalOrders++
    })
    this.loading = false
    this.data = obj
  }).catch(e => {
    console.log(e)
  })
}

methods.configurePercent = function (val) {
  return (parseFloat(val.total) / parseFloat(this.total)) * 100
}

methods.configurePercentOrders = function (val) {
  return (parseFloat(val.totalOrders) / parseFloat(this.totalOrders)) * 100
}

methods.configurePercentUnits = function (val) {
  return (parseFloat(val.total_units) / parseFloat(this.totalUnits)) * 100
}

export default {
    // ===Component name
    name: "CustomerChartDash",
    // ===Props passed to component
    props: ['customer_selected'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: null,
          total: 0,
          totalOrders: 0,
          totalUnits: 0,
          loading: true,
          collapsed: false
        }
    },
    watch: {
      collapsed: function (newVal, oldVal) {
        if (newVal) {
          this.getData()
        }
      }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      // this.getData()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
